import React, { useMemo, useState } from "react";
import {
  Popover,
  MenuItem,
  MenuList,
  IconButton,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";

const CopyPopover = ({ items = [] }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopy = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text.toString());
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "copy-popover" : undefined;

  return (
    <div>
      <Tooltip placement="top" title={t("Copy")}>
        <IconButton onClick={handleClick} color="inherit" size="small">
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>

      <Popover
        disableScrollLock={true}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <MenuList>
          {items?.map((item, index) => (
            <MenuItem
              key={index}
              sx={{ fontSize: "1rem" }}
              onClick={() => handleCopy(item.value)}
            >
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </div>
  );
};

export default CopyPopover;
